import { init } from 'smolcart.js';

/**
 * add the bundle to the cart!
 *
 * @param {*} state
 */
export const addBundleToCart = (state) => {
  const atcItems = state.items
    .filter((item) => {
      const validQuantity = item.quantity > 0;
      const available = item.variant.available;
      return validQuantity && available;
    })
    .map(({ variant, quantity }) => {
      return {
        id: variant.id,
        quantity,
      };
    });
  atcItems.push({
    id: state.bundle.variant.id,
    quantity: 1,
  });
  const cart = init();
  return cart.addItems(atcItems);
};

/**
 * add a single item to the cart
 *
 * @param {*} state
 */
export const addItemToCart = (id, quantity) => {
  const cart = init();
  return cart.addItems([
    {
      id,
      quantity,
    },
  ]);
};
